import { render, staticRenderFns } from "./DownloadManager.vue?vue&type=template&id=bc64ed4e&scoped=true"
import script from "./DownloadManager.vue?vue&type=script&lang=js"
export * from "./DownloadManager.vue?vue&type=script&lang=js"
import style0 from "./DownloadManager.vue?vue&type=style&index=0&id=bc64ed4e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc64ed4e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FileList: require('/usr/src/app/components/file/FileList.vue').default})
